import { render, staticRenderFns } from "./AddDocuments.vue?vue&type=template&id=d0c49a96&scoped=true"
import script from "./AddDocuments.vue?vue&type=script&lang=js"
export * from "./AddDocuments.vue?vue&type=script&lang=js"
import style0 from "./AddDocuments.vue?vue&type=style&index=0&id=d0c49a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c49a96",
  null
  
)

export default component.exports